
import React from 'react';

/**
 *
 * @param {string} Location
 * @param {string} Name
 * @param {Array} Times array<{ Date, Modes }>
 * @param {string} Info
 * @param {lat, lng} Geolocation {lat, lng}
 * @param {alt, src} Image {alt, src}
 * @param {func} onProviderSelect
 *
 */
// {
// 	"Date": "Monday, 7 March at 1:00pm - 1:30pm",
// 	"Modes": [
// 		"face to face",
// 		"drop in",
// 		"online video call",
// 		"telephone call",
// 		"online chat"
// 	]
// },
const ProviderCard = (props) => {
	const {
		// provider fields
		Location,
		Name,
		Times,
		Info,
		Geolocation,
		Image,
		onProviderSelect,
	} = props;

	const renderIcons = (modes) => {
		return (
			<div className="providerCard-icons">
				{ modes.includes('face to face') ?
					<div className="providerCard-icons-img-wrapper" ><img src={`../../assets/images/reactMakeAppointmentContainer/1.svg`} alt={Image.Alt} /></div> : null
				}
				{ modes.includes('drop in') ?
					<div className="providerCard-icons-img-wrapper" ><img src={`../../assets/images/reactMakeAppointmentContainer/2.svg`} alt={Image.Alt} /></div> : null
				}
				{ modes.includes('online video call') ?
					<div className="providerCard-icons-img-wrapper" ><img src={`../../assets/images/reactMakeAppointmentContainer/3.svg`} alt={Image.Alt} /></div> : null
				}
				{ modes.includes('telephone call') ?
					<div className="providerCard-icons-img-wrapper" ><img src={`../../assets/images/reactMakeAppointmentContainer/4.svg`} alt={Image.Alt} /></div> : null
				}
				{ modes.includes('online chat') ?
					<div className="providerCard-icons-img-wrapper" ><img src={`../../assets/images/reactMakeAppointmentContainer/5.svg`} alt={Image.Alt} /></div> : null
				}
			</div>
		)
	};

	return (
		<div className="providerCard mb-1 ">
			<div className="d-flex border-bottom mb-1 pb-1">
				<div className="providerCard-img">
					<img src={Image.Src} alt={Image.Alt} />
				</div>
				<div>
					<span className="fsp-14">{Location}</span>
					<div className="providerCard-name">{Name}</div>
				</div>
			</div>

			<div className="row">
			{
				Times && Times.length > 0 &&
				Times.map((timeSlot, i) => (
					<div key={i} className="col-lg-4 col-6" onClick={() => onProviderSelect(props, timeSlot)}>
						<div className={`providerCard-time-card`}>
							<div className={`date`}>{timeSlot.Date}</div>
							{
								timeSlot.Modes && timeSlot.Modes.length > 0 &&
								renderIcons(timeSlot.Modes)
							}
						</div>

					</div>
				))
			}
			</div>
		</div>
	);
};

export default ProviderCard;
